import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, PropType, computed, watch, Ref } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import { upsertUser } from '@/api/operation'
import { ElMessage, ElMessageBox } from 'element-plus'
import { FieldEnable } from '@/types/types'
import FormRulesFactory from '@/common/formRules'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'UserEditDialog',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  user: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { emit }) {

const props = __props

const userFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['nickName'], 'inputEmpty', 'inputInvalid'),
  ...FormRulesFactory.generateCustomRules(['email'], 'inputEmpty', 'inputInvalid', {
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  }),
})

// const {} = useProtocolEnums()

const { t, tl } = useI18nTl('Operation')



let subsForm = ref()
const record = ref<Record<string, any>>({})

const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      subsForm.value?.clearValidate()
      record.value = { carPrice: { dayTariff: { tariffs: [] } } }
    }
  },
})

const submit = async () => {
  await subsForm.value?.validate()

  if (record.value.enable) {
    record.value.enable = FieldEnable.CES_ENABLE
  } else {
    record.value.enable = FieldEnable.CES_DISABLE
  }
  upsertUser(record.value).then((res: any) => {
    ElMessage.success(t(`Base.editSuccess`))
    showDialog.value = false
    emit('submitted')
  })
}

watch(
  () => props.modelValue,
  (val) => {
    if (props.modelValue) {
      record.value.id = props.user?.id
      record.value.account = props.user?.account
      record.value.passwd = props.user?.passwd
      record.value.operatorName = props.user?.operatorName
      record.value.nickName = props.user?.nickName
      record.value.phone = props.user?.phone
      record.value.email = props.user?.email
      record.value.address = props.user?.address
      record.value.enable = props.user?.enable
    }
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "65%",
    class: "upsert-dialog",
    title: _ctx.$t('Operation.editUser'),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.saveChanges')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: userFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.account'),
                    prop: "account",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: record.value.account,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.account) = $event)),
                                disabled: true
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 1 }),
                          _createVNode(_component_el_col, { span: 3 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_switch, {
                                modelValue: record.value.enable,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.enable) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.passwd'),
                    prop: "passwd",
                    "aria-readonly": "true"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.passwd,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.passwd) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorName",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.operatorName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.operatorName) = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.nickname'),
                    prop: "nickName",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.nickName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.nickName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.phone'),
                    prop: "phone",
                    "aria-readonly": "true"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.phone,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.phone) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.email'),
                    prop: "email",
                    "aria-readonly": "true",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.email,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((record.value.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.address'),
                    prop: "address",
                    "aria-readonly": "true"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.address,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((record.value.address) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})